import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "tooltipPlacement", "tooltipProps", "title", "children", "color", "size", "alignWithText"];
import { Tooltip } from '../Tooltip';
import { InfoIcon } from 'foundations-assets';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import styled from 'foundations-theming/utils';
import { Spacer } from '../../../components/Spacer/Spacer';
import { View } from '../View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSpan = styled.span.withConfig({
  displayName: "HelpIcon__StyledSpan",
  componentId: "ihfz1w-0"
})(({
  $cssStyles,
  $alignWithText
}) => {
  return Object.assign({
    cursor: 'default',
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: 'inherit'
  }, $alignWithText ? {
    verticalAlign: '-0.15em' // This value was chosen based on the icon svg alignment within its viewbox
  } : undefined, $cssStyles);
});
const mapSizeToIconSize = {
  small: '300',
  // 16px
  medium: '800',
  // 32px
  large: '900' // 48px
};
export const HelpIcon = _ref => {
  let {
      use = 'default',
      tooltipPlacement,
      tooltipProps,
      title,
      children,
      color,
      size,
      alignWithText = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const iconColor = color || (use === 'on-dark' ? 'icon-core-on-fill-default' : 'icon-core-subtle');
  const computedTooltipPlacement = !tooltipPlacement && tooltipProps && tooltipProps.placement ? tooltipProps.placement : tooltipPlacement;
  const iconSize = typeof size === 'string' && size in mapSizeToIconSize ? mapSizeToIconSize[size] : size;
  return /*#__PURE__*/_jsxs(StyledSpan, Object.assign({
    $cssStyles: cssStyles,
    $alignWithText: alignWithText
  }, domProps, {
    children: [children, children && /*#__PURE__*/_jsx(Spacer, {
      space: "200",
      display: "inline-block"
    }), /*#__PURE__*/_jsx(Tooltip, Object.assign({}, tooltipProps, {
      placement: computedTooltipPlacement,
      title: title,
      children: /*#__PURE__*/_jsx(View, {
        as: "span",
        children: /*#__PURE__*/_jsx(InfoIcon, {
          color: iconColor,
          size: iconSize
        })
      })
    }))]
  }));
};